<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'系统配置'},{name:'角色权限管理',goback:true},{name:'新增角色'}]" :title="'新增角色'"/>
            <!-- 表单 -->
            <div class="box">
                 <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>角色名称：</div>
                        <el-input v-model="sendInfoTwo.roleName" maxlength="20" placeholder="限20字"></el-input>
                    </div>
                    <div class="error" v-if="errors['sendInfoTwo.roleName']">错误提示：{{errors['sendInfoTwo.roleName']}}</div>
                    <div class="child">
                        <div class="name"><span>*</span>角色编码：</div>
                        <el-input v-model="sendInfoTwo.roleCode" placeholder="限50字" maxlength="50"></el-input>
                    </div>
                    <div class="error" v-if="errors['sendInfoTwo.roleCode']">错误提示：{{errors['sendInfoTwo.roleCode']}}</div>
                    <div class="child" style="align-items:flex-start">
                        <div class="name">说明：</div>
                        <div class="content"><el-input type="textarea" placeholder="限50字" :autosize="{ minRows: 4}" v-model="sendInfoTwo.remarks" show-word-limit maxlength="50"></el-input></div>
                    </div>
                    <div class="child">
                        <div class="name"></div>
                        <div class="content">
                          <div class="doubleBtn">
                              <el-button size="small" type="primary" @click="submit">确认</el-button>
                              <el-button size="small" @click="cancel">取消</el-button>
                          </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import upLoadFiles from '../../components/upLoadFiles';
import upLoad from '../../components/upLoad';
import wangEditor from 'wangeditor';
import wangEnduit from '../../components/wangEnduit';
export default {
    components:{
        breadcrumb,
        upLoadFiles,upLoad,wangEnduit
    },
    data(){
        return{
            id:void 0,
            sendInfoTwo:{
                id:null,//角色id
                roleName:null,//角色名称：
                roleCode:null,//角色编码
                remarks:null,//描述
            },//编辑提交数据
            transferList:[],//穿梭框数据
            administratorTypeList:[],//管理员类型数组
            editor:null,//富文本编辑器容器
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        },
    },
    vuerify: {
        'sendInfoTwo.roleName':{
            test:'realName',
            message:'角色名称错误'
        },
        'sendInfoTwo.roleCode':{
            test:/^[A-Za-z]{1,50}$/,
            message:'角色编码错误'
        }
    },
    methods:{
      
		getDetail(id){
			this.$axiosz.get('backstage/sysRole/view/'+id).then((r)=>{
			    if(r.code==200){
                       this.sendInfoTwo.id=id;
                        this.sendInfoTwo.roleName=r.data.roleName;
                        this.sendInfoTwo.roleCode=r.data.roleCode;
                        this.sendInfoTwo.remarks=r.data.remarks;
                    }else{
                        this.$alert(r.msg)
                    }
			})
		},
        cancel(){
          this.$router.back(-1)
        },
        //保存按钮
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check(['sendInfoTwo.roleName','sendInfoTwo.roleCode'])){
                if(this.sendInfoTwo.id){//编辑
                    this.$axiosz.put("backstage/sysRole/"+this.sendInfoTwo.id,this.$qs.stringify(this.sendInfoTwo)).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                message: this.editTitle+'成功！',
                                type: 'success'
                            });
                            this.dialogEdit=false;
                            this.getData();
                        }else{
                            this.$alert(r.msg)
                        }
                    })
                }else{ //发布
                    this.$axiosz.post("backstage/sysRole",this.$qs.stringify(this.sendInfoTwo)).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                message: this.editTitle+'成功！',
                                type: 'success'
                            });
                            this.dialogEdit=false;
                            this.getData();
                        }else{
                            this.$alert(r.msg)
                        }
                    })
                }
                
            }
        },
    },
    mounted(){
        // this.editor = new wangEditor(this.$refs.wangEditor);
        // this.editor.customConfig.onchange =  (html) => { //通过富文本变化赋值
        //     // html 即变化之后的内容
        //     this.sendInfo.content=html;
        //     this.$vuerify.check(['sendInfo.content']);
        // }
        // this.editor.create();
    },
	created() {
    const {id} = this.$route.params
    this.id= id || void 0
		if(id){
		    this.sendInfoTwo.id=id;
			  this.getDetail(id);
		}
	}
}
</script>

<style lang="scss" scoped>
.warp{
     height:93%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
      padding:100px 0;
        .forms{
            max-width: 610px;
            margin: auto;
            transform: translateX(-100px);
            .child{
                .name{
                  width:80px;
                  text-align: right;
                  margin-right:10px;
                }
                .content{
                    flex: 1;
					/deep/ .ql-container{
						min-height: 410px;
					}
                }
            }
        }
    }
}
</style>
